<template>
  <div class="slide zoom" v-parallax-fit="parallax">
    <div class="maze"></div>
    <div class="hand"></div>
  </div>
</template>

<script>
export default {
  name: 'slide14_4',
  mounted() {
    const text = {
		'en': `Vanessa's nightmare in trying to secure a loan modification was not unique to her. According to this study, the Home Affordable Modification Program (HAMP) whose aim was to prevent foreclosure by offering incentives to banks to modify loans, could have helped 70% more homeowners had bank lenders been better organized. "Many big banks and mortgage-servicing companies apparently weren’t up to the job, even if it was in their financial interest. A significant share of those companies lacked the organizational capacity to renegotiate large numbers of loans and opted not to make internal changes that would have enabled them to take advantage of the program," resulting in millions more foreclosures than necessary.`,
		'es': 'La pesadilla de Vanessa al tratar de conseguir una modificación de préstamo no era exclusiva de ella. Según este estudio, el Programa de Modificación de Vivienda Asequible (HAMP), cuyo objetivo era evitar la ejecución hipotecaria ofreciendo incentivos a los bancos para modificar los préstamos, podría haber ayudado a un 70 % más de propietarios si los prestamistas bancarios hubieran estado mejor organizados. "Muchos grandes bancos y empresas de servicios hipotecarios aparentemente no estaban a la altura del trabajo, incluso si era en su interés financiero. Una parte significativa de esas empresas carecía de la capacidad organizativa para renegociar una gran cantidad de préstamos y optó por no hacer cambios internos. eso les habría permitido aprovechar el programa", lo que resultó en millones más de ejecuciones hipotecarias de las necesarias.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(0px) translateX(0px) rotateZ(0deg)') {
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide14_4'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 13700,
          end: 14200,
          fromStyle: { transform: 'translateY(1600px) translateX(800px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 15000,
          end: 15500,
          fromStyle: { transform: 'translateY(1px) translateX(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1600px) translateX(800px) rotateZ(0deg)' },
          easing: 'linear'
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transition: 0.5s;
    z-index: 5;
    left: calc(50% + 2px);
    top: calc(50% - 480px);
    @media(max-width: 600px) {
      left: calc(50% + 32px);
      top: calc(50% - 260px);
    }

    .maze {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_PaperMaze_4.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 552px;
      height: 530px;
      left: 0;
      top: 301px;
      @media(max-width: 600px) {
        width: 264px;
        left: -63px;
        top: calc(50% - 270px);
      }
    }

    .hand {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_Hand_4.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 301px;
      height: 1190px;
      left: 551px;
      top: 216px;
      transform: rotateZ(-64deg);
      @media(max-width: 600px) {
        left: 71px;
        top: calc(50% - 220px);
        transform: rotateZ(-24deg);
      }
    }
}
</style>
